import { initialUOTState, IUOTState } from '../state/uot.state';
import { UOTAction, EUOTActions } from '../actions/uot.action';

export function uotReducers(state = initialUOTState, action: UOTAction): IUOTState {
    switch (action.type) {

        case EUOTActions.GetUOTDetails: {
            return {
                ...state,
                getUOTDetails: action.payload,
                getUOTErrorMessage: null
            };
        }
        case EUOTActions.SetUOTSuccess: {
            const success = {
                data : action.payload,
                from : action.from
            }
            return {
                ...state,
                getUOTSuccessMessage: success,
                getUOTErrorMessage: null
            };
        }
        case EUOTActions.SetUOTError: {
            const error = {
                data : action.payload,
                from : action.from
            }
            return {
                ...state,
                getUOTErrorMessage: error,
                getUOTDetails: null
            };
        }
        case EUOTActions.GetAllProductTypesSuccess: {
            return {
                ...state,
                getAllProducttypesSuccess: action.payload,
                getAllProducttypesError: null
            };
        }
        case EUOTActions.GetAllProductTypesError: {
            return {
                ...state,
                getAllProducttypesError: action.payload,
                getAllProducttypesSuccess: null
            };
        }
        case EUOTActions.GetAddProductTypeSuccess: {
            return {
                ...state,
                getAddProductTypeSuccess: action.payload,
                getAddProductTypeError: null
            };
        }
        case EUOTActions.GetAddProductTypeError: {
            return {
                ...state,
                getAddProductTypeError: action.payload,
                getAddProductTypeSuccess: null
            };
        }
        case EUOTActions.GetEditProductTypeSuccess: {
            return {
                ...state,
                getEditProductTypeSuccess: action.payload,
                getEditProductTypeError: null
            };
        }
        case EUOTActions.GetEditProductTypeError: {
            return {
                ...state,
                getEditProductTypeError: action.payload,
                getEditProductTypeSuccess: null
            };
        }
        default: {   
            return state;
          }
    }

}